import { useState } from "react";
import DashboardLayout from "../../components/layout/DashboardLayout";
import { Card, CardContent, CardHeader, CardTitle } from "../../components/ui/card";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { User, Mail, Phone, Loader2 } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL || ""}/api`;

export default function CustomerProfile() {
  const { user, token, updateUser } = useAuth();
  const [formData, setFormData] = useState({
    name: user?.name || "",
    phone: user?.phone || ""
  });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const headers = token ? { Authorization: `Bearer ${token}` } : {};
      const response = await axios.put(
        `${API}/users/${user.user_id}`,
        formData,
        { headers, withCredentials: true }
      );
      
      updateUser(response.data);
      toast.success("Profilo aggiornato");
    } catch (error) {
      toast.error("Errore durante l'aggiornamento");
    } finally {
      setLoading(false);
    }
  };

  return (
    <DashboardLayout title="Profilo">
      <div className="max-w-2xl" data-testid="customer-profile">
        <Card>
          <CardHeader>
            <CardTitle style={{ fontFamily: 'Chivo, sans-serif' }}>
              Informazioni Personali
            </CardTitle>
          </CardHeader>
          <CardContent>
            <form onSubmit={handleSubmit} className="space-y-4">
              {/* Avatar */}
              <div className="flex items-center gap-4 mb-6">
                {user?.picture ? (
                  <img src={user.picture} alt={user.name} className="h-16 w-16 rounded-full" />
                ) : (
                  <div className="h-16 w-16 rounded-full bg-primary flex items-center justify-center text-primary-foreground text-2xl font-bold">
                    {user?.name?.charAt(0).toUpperCase()}
                  </div>
                )}
                <div>
                  <p className="font-bold">{user?.name}</p>
                  <p className="text-sm text-muted-foreground">{user?.email}</p>
                </div>
              </div>

              <div>
                <Label htmlFor="name" className="input-label">Nome Completo</Label>
                <div className="relative">
                  <User className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
                  <Input
                    id="name"
                    value={formData.name}
                    onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                    className="pl-10"
                    data-testid="profile-name"
                  />
                </div>
              </div>

              <div>
                <Label htmlFor="email" className="input-label">Email</Label>
                <div className="relative">
                  <Mail className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
                  <Input
                    id="email"
                    value={user?.email}
                    disabled
                    className="pl-10 bg-muted"
                  />
                </div>
                <p className="text-xs text-muted-foreground mt-1">L'email non può essere modificata</p>
              </div>

              <div>
                <Label htmlFor="phone" className="input-label">Telefono</Label>
                <div className="relative">
                  <Phone className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
                  <Input
                    id="phone"
                    value={formData.phone}
                    onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                    className="pl-10"
                    placeholder="+39 123 456 7890"
                    data-testid="profile-phone"
                  />
                </div>
              </div>

              <Button type="submit" className="btn-primary" disabled={loading} data-testid="save-profile">
                {loading ? (
                  <>
                    <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                    Salvataggio...
                  </>
                ) : (
                  "Salva Modifiche"
                )}
              </Button>
            </form>
          </CardContent>
        </Card>
      </div>
    </DashboardLayout>
  );
}
